import { extendTailwindMerge } from "tailwind-merge";
import clsx, { ClassValue } from "clsx";

/**
 * Default tailwind-merge only treats T-shirt text scales (text-sm, text-xl, …) as font-size.
 * Our @theme sizes (e.g. text-btn-small) would otherwise match text-color and conflict with
 * text-white. Register them on the text theme so they stay in the font-size group.
 * @see https://github.com/dcastil/tailwind-merge/blob/main/docs/configuration.md
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "default",
        "smaller",
        "small",
        "btn-small",
        "btn-large",
        "btn-tertiary",
      ],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
